import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";

interface TablePanelProps<T> {
  title: string;
  columns: { label: string; key: keyof T }[];
  data: T[];
  renderCell?: (key: keyof T, value: any, row: T) => React.ReactNode;
  count: number;
  onViewMore?: () => void;
  onCellClick?: (key: keyof T, row: T) => void; // 👈 added new prop
}

const TablePanel = <T,>({
  title,
  columns,
  data,
  renderCell,
  count,
  onViewMore,
  onCellClick,
}: TablePanelProps<T>) => {
  return (
    <div className="cards table_cards">
      <div className="cards_header">
        <div className="left_s">
          <h2>{title}</h2>
        </div>
        <div className="right_s">
          {count > 10 && (
            <Button className="btn sm btn_primary" onClick={onViewMore}>
              View More
            </Button>
          )}
        </div>
      </div>
      <div className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              {columns?.map((col) => (
                <TableCell key={String(col?.key)}>{col?.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.length ? (
              data?.map((row, idx) => (
                <TableRow key={idx}>
                  {columns?.map((col) => {
                    const value = row[col?.key];
                    const cellContent = renderCell
                      ? renderCell(col?.key, value, row)
                      : (value as string) || "-";

                    return (
                      <TableCell
                        key={String(col?.key)}
                        onClick={() =>
                          (col?.key === "name" || col?.key === "offerName") &&
                          onCellClick
                            ? onCellClick(col?.key, row)
                            : undefined
                        }
                        style={
                          col?.key === "name" || col?.key === "offerName"
                            ? { cursor: "pointer" }
                            : {}
                        }
                      >
                        {cellContent}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns?.length || 1} align="center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default TablePanel;
